import {  useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
} from '@mui/material';
import { SidebarContext } from '../../../../contexts/SidebarContext';
import useQuery from '../../../../shared/components/hooks/useQuery';
import { ProfileBorderBox } from '../../../../shared/components/profileComponents';
import { TitleBarProps } from '../../../../shared/components/titleBar';
import { ViewContainer } from '../../../../shared/components/viewContainer';
import SingleEntityContainer from '../../../../shared/components/singleEntityContainer';
import { getTextFields } from '../variables/getTextFields';

const StudentDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { payload } = useContext(SidebarContext);

  const { loading, data } = useQuery(`/parent-students/${id}`, {
    params: payload
  });

  const studentData = (data as any)?.data || {};

  if (loading || !studentData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography>Loading...</Typography>
      </Box>
    );
  }


const titleBar: TitleBarProps = {
    title: "Student Overview",
    editCloseIcon: {
      visible: true,
      onClick: () => {
        localStorage.removeItem("selectedStudentId");
        navigate("/dashboard");
      },
    },
  };

  const userEditFields = getTextFields(studentData);

  return (
    <ProfileBorderBox>
          <ViewContainer loading={loading} titleBar={titleBar}>
            <div className="entity-container" style={{ marginTop: '20px' }}>
              <SingleEntityContainer
                entityFields={userEditFields}
              ></SingleEntityContainer>
            </div>
          </ViewContainer>
        </ProfileBorderBox>
  );
};

export default StudentDetails;